import { render, staticRenderFns } from "./Paper_ssdt.vue?vue&type=template&id=1a074f2c&scoped=true&"
import script from "./Paper_ssdt.vue?vue&type=script&lang=js&"
export * from "./Paper_ssdt.vue?vue&type=script&lang=js&"
import style0 from "./Paper_ssdt.vue?vue&type=style&index=0&id=1a074f2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a074f2c",
  null
  
)

export default component.exports